module.exports = __webpack_public_path__ + "static/media/cocktail.220cfacb.svg";